import * as _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import { ObjectTypeWkf } from '../../../models/ObjectTypeWkf';
import { WorkflowModelInfos } from '../../../models/workflow/workflowModelInfos';
import {
  createActionLoadWorkflowModelInfosProcessFailedAction,
  createActionLoadWorkflowModelInfosProcessStartAction,
  createActionLoadWorkflowModelInfosProcessSucceededAction,
  createActionLoadWorkflowModelInfosTaskFailedAction,
  createActionLoadWorkflowModelInfosTaskStartAction,
  createActionLoadWorkflowModelInfosTaskSucceededAction
} from '../action/workflow-model-infos-action';



export class WorkflowModelInfosState {
  datas: { -readonly [objectTypeWkf in ObjectTypeWkf]?: WorkflowModelInfos[] };
  loading: boolean;
  error: any;
}

const initStore: { -readonly [objectTypeWkf in ObjectTypeWkf]?: WorkflowModelInfos[] } = WorkflowModelInfos.getInitStore();

export const WORKFLOW_MODEL_LABELS_INITIAL_STATE: WorkflowModelInfosState = {
  datas: initStore,
  loading: false,
  error: null
};



export const workflowModelInfosReducer = createReducer(
  WORKFLOW_MODEL_LABELS_INITIAL_STATE,
  on(createActionLoadWorkflowModelInfosProcessStartAction,(state) =>({
    ...state,
    loading: true,
    error: null,
  })),
  on(createActionLoadWorkflowModelInfosProcessSucceededAction,(state, {payload} )=>

    {
      const newDatas = _.cloneDeep(state.datas);
      newDatas.PROCESSUS = payload;

      return ({
        ...state,
        datas: newDatas,
        loading: false,
        error: null,
      })
    }
  ),
  on(createActionLoadWorkflowModelInfosProcessFailedAction,(state, {error}) =>({
    ...state,
    loading: false,
    error: error,
  })),

  on(createActionLoadWorkflowModelInfosTaskStartAction,(state) =>({
    ...state,
    loading: true,
    error: null,
  })),
  on(createActionLoadWorkflowModelInfosTaskSucceededAction,(state, {payload} )=>

  {
    const newDatas = _.cloneDeep(state.datas);
    newDatas.TASK = payload;

    return ({
    ...state,
    datas: newDatas,
    loading: false,
    error: null,
    })
  }
  ),
  on(createActionLoadWorkflowModelInfosTaskFailedAction,(state, {error}) =>({
    ...state,
    loading: false,
    error: error,
  })),
);
